
export default function DynamicFilterSliders({ sliderData = [], checkedFilters, onLoadMore, isLoading }) {
    return (
        <>
            {/* Header */}
            <div className="delivery_restaurant_header mt-3">
                <h2 className='mb-0'>{Object.keys(checkedFilters).join(", ")}</h2>
            </div>

            {/* Cards */}
            <div className="row gy-4 pt-4">
                {sliderData.length > 0 ? (
                    sliderData.map((ele, index) => (
                        <div className="col-lg-4 col-md-12" key={index}>
                            <div className="card-item">
                                <div className="resorts-box p-3 bg-white h-100">
                                    <figure>
                                        <img
                                            src={ele?.image_url}
                                            alt="images"
                                            loading="lazy"
                                            className="img-fluid"
                                        />
                                    </figure>

                                    <div className="resorts-content-box">
                                        <div className="d-flex justify-content-between">
                                            <span className="rating-star">
                                                <i className="fa-solid fa-star"></i>
                                                {ele?.rating} Overall Reviews
                                            </span>
                                        </div>

                                        <div className="resort-description border-0 m-0">
                                            <h3>
                                                {ele?.name?.length >= 18
                                                    ? `${ele.name.slice(0, 18)}...`
                                                    : ele?.name}
                                            </h3>
                                        </div>

                                        <div className="book-trip-btn">
                                            <a
                                                href={ele?.url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="w-100 text-center d-block"
                                            >
                                                Order Now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center">
                        <p>No restaurants found</p>
                    </div>
                )}
            </div>

            {/* Load more */}
            <div className="d-flex justify-content-center align-items-center mt-4">
                <button className="view-all-btn text-center d-block" onClick={onLoadMore} disabled={isLoading}>
                    {isLoading ? "Loading..." : "Load More"}
                </button>
            </div>
        </>
    );
}
